import AXIOS from "./axios";

export class WireCardAccount {
  static activate(price_cents) {
    let formattedPrice = price_cents.replace("R$ ", "");
    let price = formattedPrice * 100;
    return AXIOS.post("/gateway_payments/accounts", {
      price_cents: price
    });
  }
}
